import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api'
import { AffiliateDashboardTagsInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export const useAffiliateDashboardTags = () => {
  const { fetcher } = useFetch<RequestMethodsEnum.get, AffiliateDashboardTagsInterface>({
    method: RequestMethodsEnum.get,
  })
  const { user } = useUser()
  return useSWR(() => {
    if (!user) return
    return `${AFFILIATE_DASHBOARD_API}/filters`
  }, fetcher)
}
